<div>
    <div class="status-message">
        Validating authentication status...
    </div>
</div>
